import gql from 'graphql-tag';

export default gql`
  mutation orderCreate($draftToken: String!, $storeId: String!, $voucherIds: [Int], $totalAfterAppliedVouchers: Float) {
    orderCreate(
      draftToken: $draftToken
      storeId: $storeId
      voucherIds: $voucherIds
      totalAfterAppliedVouchers: $totalAfterAppliedVouchers
    ) {
      orders {
        id
        total
        totalItemPrice
        items {
          product {
            id
          }
        }
      }
      success
      userErrors {
        field
        message
      }
      cart {
        redInvoiceInfo {
          registeredName
          registeredAddress
          redInvoiceNumber
        }
        deliveryNotes
        cartSet {
          paymentMethod
          deliveryNotes
          orderDeadline
          supplier {
            fulfillmentTime {
              hoursToDelivery
              days
              cutoffTime
            }
            moq
            id
            name
            private
          }
          earliestDate
          deliveryDatetime {
            start
            end
          }
          deliveryTimeSlots {
            start
            end
          }
          total
          items {
            product {
              supplierInternalCode
              id
              name
              imageUrl
              note
              vat
              uom
              uomLocal
              price
              allowPurchase
              inStock
              category {
                name
                parent {
                  name
                }
              }
            }
            quantity
          }
        }
        store {
          id
          freeShipping
          moq
        }
      }
    }
  }
`;
